import type { AxiosPromise } from 'axios'
import request from '@user-center/utils/request'

export function getNewCustomerTaskCenter(data: any): AxiosPromise<unknown> {
  return request({ url: '/marketingActivity/userTaskCenter', method: 'post', data })
}

export function joinNewCustomerTaskActivity(data: any): AxiosPromise<unknown> {
  return request({ url: '/marketingActivity/userTaskActivity/join', method: 'post', data })
}

export function reportNewCustomerTaskAction(data: any): AxiosPromise<unknown> {
  return request({ url: '/marketingActivity/userTaskAction/report?hiddenErrTip=1', method: 'post', data })
}

export function completeNewCustomerTaskAction(data: any): AxiosPromise<unknown> {
  return request({ url: '/marketingActivity/userTaskAction/complete', method: 'post', data })
}
